import angular from 'angular';
import { config } from './remove.offer.config';
import RemoveOfferComponent from './remove.offer.component';
export default angular.module('invision.customercare.customer.remove.offer', []).config(config).component('removeOffer', RemoveOfferComponent).name;